// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"069d09f2","651":"ee104ac7"}[chunkId] + ".chunk.js";
};